import type { Messages } from './types';
import core from './ja/core';
import simopsRoutes from './ja/simopsRoutes';
import simopsShared from './ja/simopsShared';
import simopsAnalysis from './ja/simopsAnalysis';
import simopsDesignPoints from './ja/simopsDesignPoints';
import simopsDraft from './ja/simopsDraft';
import simopsFiles from './ja/simopsFiles';
import simopsMeshing from './ja/simopsMeshing';
import simopsReport from './ja/simopsReport';
import simopsSolver from './ja/simopsSolver';
import simopsMisc from './ja/simopsMisc';
import simopsNew from './ja/simopsNew';
import meshgen from './ja/meshgen';
import diagnosisRoutes from './ja/diagnosisRoutes';
import diagnosisComponents from './ja/diagnosisComponents';
import auth from './ja/auth';
import compCommon from './ja/compCommon';
import compMesh from './ja/compMesh';
import compAssistant from './ja/compAssistant';
import compProductLibrary from './ja/compProductLibrary';
import compMisc from './ja/compMisc';
import commands from './ja/commands';
import cadmorph from './ja/cadmorph';

/** Japanese (日本語). Typed as Messages → missing keys fail the build. */
const ja: Messages = {
  ...core,
  simopsRoutes,
  simopsShared,
  simopsAnalysis,
  simopsDesignPoints,
  simopsDraft,
  simopsFiles,
  simopsMeshing,
  simopsReport,
  simopsSolver,
  simopsMisc,
  simopsNew,
  meshgen,
  diagnosisRoutes,
  diagnosisComponents,
  auth,
  compCommon,
  compMesh,
  compAssistant,
  compProductLibrary,
  compMisc,
  commands,
  cadmorph,
};

export default ja;
